export class EquityConstants {
	public static readonly EMERGING_MARKETS = ['US', 'Developed', 'Emerging', 'Other'];
	public static readonly INTERNATIONAL = 'INTERNATIONAL';
	public static readonly OTHER = 'Other';
}
